import React, { useState } from "react";
import { useForm, ValidationError } from "@formspree/react";
import {
  Button,
  Grid,
  FormControl,
  Typography,
  Box,
  MenuItem,
  Select,
} from "@mui/material";
import useSuccessfulMetaSubmission from "../../hooks/useSuccessfulMetaSubmission";

function WholesaleForm() {
  const [state, handleSubmit] = useForm("xdaelzoj");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    businessName: "",
    businessAddress: "",
    businessType: "",
    referral: "",
  });

  useSuccessfulMetaSubmission(state.succeeded, formData, "Wholesale Inquiry Submission");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const inputStyle = {
    padding: "10px",
    marginTop: "5px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    outline: "none",
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: "#283341",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          maxWidth: "800px",
          width: "90%",
          color: "white",
          mt: 5,
          position: "relative",
          zIndex: 2,
          "*": {
            fontFamily: "Roboto, sans-serif !important",
          },
        }}
      >
        <Box sx={{ maxWidth: "640px", width: "100%", mx: "auto" }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: "400", textAlign: "center", mb: 2 }}
          >
            WHOLESALE INQUIRY
          </Typography>
          <Typography
            variant="body1"
            sx={{ mb: 3, lineHeight: 2, textAlign: "center", px: 2 }}
          >
            Interested in partnering with us? Fill out the form and we'll get back to you shortly!
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/* First Name */}
            <Grid item xs={6}>
              <FormControl fullWidth>
                <label htmlFor="wholesale-firstName" style={{ fontSize: "14px" }}>
                  First Name <span style={{ color: "#f56c6c" }}>*</span>
                </label>
                <input
                  id="wholesale-firstName"
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  style={inputStyle}
                  required
                />
              </FormControl>
            </Grid>

            {/* Last Name */}
            <Grid item xs={6}>
              <FormControl fullWidth>
                <label htmlFor="wholesale-lastName" style={{ fontSize: "14px" }}>
                  Last Name <span style={{ color: "#f56c6c" }}>*</span>
                </label>
                <input
                  id="wholesale-lastName"
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  style={inputStyle}
                  required
                />
              </FormControl>
            </Grid>

            {/* Email */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <label htmlFor="wholesale-email" style={{ fontSize: "14px" }}>
                  Email <span style={{ color: "#f56c6c" }}>*</span>
                </label>
                <input
                  id="wholesale-email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  style={inputStyle}
                  required
                />
                <ValidationError
                  prefix="Email"
                  field="email"
                  errors={state.errors}
                />
              </FormControl>
            </Grid>

            {/* Phone */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <label htmlFor="wholesale-phone" style={{ fontSize: "14px" }}>
                  Phone <span style={{ color: "#f56c6c" }}>*</span>
                </label>
                <input
                  id="wholesale-phone"
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  style={inputStyle}
                  required
                />
              </FormControl>
            </Grid>

            {/* Business Name */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <label htmlFor="wholesale-businessName" style={{ fontSize: "14px" }}>
                  Business Name <span style={{ color: "#f56c6c" }}>*</span>
                </label>
                <input
                  id="wholesale-businessName"
                  type="text"
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleInputChange}
                  style={inputStyle}
                  required
                />
              </FormControl>
            </Grid>

            {/* Business Address */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <label htmlFor="wholesale-businessAddress" style={{ fontSize: "14px" }}>
                  Business Address <span style={{ color: "#f56c6c" }}>*</span>
                </label>
                <input
                  id="wholesale-businessAddress"
                  type="text"
                  name="businessAddress"
                  value={formData.businessAddress}
                  onChange={handleInputChange}
                  style={inputStyle}
                  required
                />
              </FormControl>
            </Grid>

            {/* Business Type Dropdown */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <label htmlFor="wholesale-businessType" style={{ fontSize: "14px", display: "block", mb: 1 }}>
                  Business Type <span style={{ color: "#f56c6c" }}>*</span>
                </label>
                <Select
                  id="wholesale-businessType"
                  name="businessType"
                  value={formData.businessType}
                  onChange={handleInputChange}
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "#fff",
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc",
                    },
                  }}
                  required
                >
                  <MenuItem value="">
                    <em>Select Business Type</em>
                  </MenuItem>
                  <MenuItem value="bakery">Bakery</MenuItem>
                  <MenuItem value="cafe-coffeeshop">Café / Coffeeshop</MenuItem>
                  <MenuItem value="hotel-hospitality">Hotel / Hospitality</MenuItem>
                  <MenuItem value="market">Market</MenuItem>
                  <MenuItem value="restaurant">Restaurant</MenuItem>
                  <MenuItem value="retail-store">Retail Store</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* How Did You Hear About Us */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <label htmlFor="wholesale-referral" style={{ fontSize: "14px" }}>
                  How Did You Hear About Us? <span style={{ color: "#f56c6c" }}>*</span>
                </label>
                <input
                  id="wholesale-referral"
                  type="text"
                  name="referral"
                  value={formData.referral}
                  onChange={handleInputChange}
                  style={inputStyle}
                  required
                />
              </FormControl>
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={state.submitting}
                sx={{
                  px: 2,
                  py: 1,
                  backgroundColor: "#00AAE3",
                  color: "white",
                  fontWeight: "bold",
                  mb: 3,
                  border: "none",
                  boxShadow: "none",
                  borderRadius: "30px",
                  fontSize: "16px",
                  textTransform: "capitalize",
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Grid>
  );
}

export default WholesaleForm;